/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * Standard error response object
 */
export type PostApiWorkspaceServiceV1WorkspacesErrorResponseData = {
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;
};

/**
 * Standard error response object
 */
export class PostApiWorkspaceServiceV1WorkspacesErrorResponse extends Error {
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;

  /** The original data that was passed to this error instance. */
  data$: PostApiWorkspaceServiceV1WorkspacesErrorResponseData;

  constructor(err: PostApiWorkspaceServiceV1WorkspacesErrorResponseData) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.error = err.error;
    if (err.code != null) this.code = err.code;
    if (err.details != null) this.details = err.details;

    this.name = "PostApiWorkspaceServiceV1WorkspacesErrorResponse";
  }
}

/** @internal */
export const PostApiWorkspaceServiceV1WorkspacesErrorResponse$inboundSchema:
  z.ZodType<
    PostApiWorkspaceServiceV1WorkspacesErrorResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    error: z.string(),
    code: z.string().optional(),
    details: z.nullable(z.any()).optional(),
  })
    .transform((v) => {
      return new PostApiWorkspaceServiceV1WorkspacesErrorResponse(v);
    });

/** @internal */
export type PostApiWorkspaceServiceV1WorkspacesErrorResponse$Outbound = {
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;
};

/** @internal */
export const PostApiWorkspaceServiceV1WorkspacesErrorResponse$outboundSchema:
  z.ZodType<
    PostApiWorkspaceServiceV1WorkspacesErrorResponse$Outbound,
    z.ZodTypeDef,
    PostApiWorkspaceServiceV1WorkspacesErrorResponse
  > = z.instanceof(PostApiWorkspaceServiceV1WorkspacesErrorResponse)
    .transform(v => v.data$)
    .pipe(z.object({
      error: z.string(),
      code: z.string().optional(),
      details: z.nullable(z.any()).optional(),
    }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiWorkspaceServiceV1WorkspacesErrorResponse$ {
  /** @deprecated use `PostApiWorkspaceServiceV1WorkspacesErrorResponse$inboundSchema` instead. */
  export const inboundSchema =
    PostApiWorkspaceServiceV1WorkspacesErrorResponse$inboundSchema;
  /** @deprecated use `PostApiWorkspaceServiceV1WorkspacesErrorResponse$outboundSchema` instead. */
  export const outboundSchema =
    PostApiWorkspaceServiceV1WorkspacesErrorResponse$outboundSchema;
  /** @deprecated use `PostApiWorkspaceServiceV1WorkspacesErrorResponse$Outbound` instead. */
  export type Outbound =
    PostApiWorkspaceServiceV1WorkspacesErrorResponse$Outbound;
}
